export const ACREOS_CHECK_BOX = "acreos-check-box";
export const ACREOS_CHECK_BOX_CHECKED = "checked";
